import { render, staticRenderFns } from "./InfoDetail.vue?vue&type=template&id=5457306c&scoped=true"
import script from "./InfoDetail.vue?vue&type=script&lang=js"
export * from "./InfoDetail.vue?vue&type=script&lang=js"
import style0 from "./InfoDetail.vue?vue&type=style&index=0&id=5457306c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457306c",
  null
  
)

export default component.exports